export default __webpack_public_path__ + "static/media/main-bottomimg.d905cab9.png";